import { TagMonster } from "./TagMonster.jsx";

export default TagMonster;
